import script from "./AtomToogleButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomToogleButton.vue?vue&type=script&lang=ts&setup=true"

import "./AtomToogleButton.vue?vue&type=style&index=0&id=78d2bd36&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d2bd36"]])

export default __exports__